// extracted by mini-css-extract-plugin
module.exports = {"quantity-select":"QuantityComboBox_quantity-select__HKUJS"};